import __request__ from "routing/request";
export function create(template, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.contentui/indicator_template", template, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAll(page = 1, page_size = 50, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.contentui/indicator_template", null, { "page": page, "page_size": page_size }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getIndicatorTemplateMapping(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.contentui/indicator_template/ui_mapping", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getById(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.contentui/indicator_template/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(template, id, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.contentui/indicator_template/${id}`, template, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.contentui/indicator_template/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
